import { useEffect, useState } from "react"
import { getError, openNotification, tryCatch } from "../common/constants/Utilities";
import { useAuth } from "../contexts/auth";
import { IDepartment } from "../interfaces/IDepartment"
import { GetDepartmentsByUserID, GetDepartments } from "../services/department";


export const useListDepartmentByUer = () => {

    // States
    const { user } = useAuth();
    const [listDepartment, setListDepartment] = useState<IDepartment[]>([]);
    const [loadingDeparment, setLoadingDepartment] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetDepartmentsByUserID();
    }, [user])

    // Handles
    const handleGetDepartmentsByUserID = () => {
        setLoadingDepartment(true);
        tryCatch(() => {
            GetDepartmentsByUserID(user!.usuarioID)
                .then((response) => {
                    setListDepartment(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingDepartment(false));
        })
    }

    return {
        listDepartment,
        loadingDeparment
    }
}

export const useListDepartment = () => {

    // States
    const { user } = useAuth();
    const [listDepartmentAll, setListDepartmentAll] = useState<IDepartment[]>([]);
    const [loadingDeparmentAll, setLoadingDeparmentAll] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetDepartmentsByUserID();
    }, [user])

    // Handles
    const handleGetDepartmentsByUserID = () => {
        setLoadingDeparmentAll(true);
        tryCatch(() => {
            GetDepartments()
                .then((response) => {
                    setListDepartmentAll(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingDeparmentAll(false));
        })
    }

    return {
        listDepartmentAll,
        loadingDeparmentAll
    }
}